import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { getExperienceTracker } from '@confluence/experience-tracker/entry-points/getExperienceTracker.ts';
import { SYSTEM_CONTENT_METADATA } from '@confluence/web-item-location/entry-points/webFragmentLocations.ts';
import { WebItemLocation } from '@confluence/web-item-location/entry-points/WebItemLocation.ts';
import { WebItemList } from '@confluence/web-item-list/entry-points/WebItemList.ts';
import { CONTENT_METADATA_PAGE_RESTRICTIONS_ID } from '@confluence/web-item/entry-points/webItemIDs.ts';

import { ConnectAppLoadEnd, getConnectAppsItems } from './cp-measure/index.js';
export class SystemContentMetadata extends PureComponent {
	static propTypes = {
		contentId: PropTypes.string.isRequired,
		versionOverride: PropTypes.number,
		excludeIds: PropTypes.arrayOf(PropTypes.string),
	};

	static defaultProps = {
		excludeIds: [],
	};

	componentDidMount() {
		const { excludeIds, contentId } = this.props;
		if (!excludeIds.includes(CONTENT_METADATA_PAGE_RESTRICTIONS_ID)) {
			getExperienceTracker().start({
				id: contentId,
				name: VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE,
			});
		}
	}

	render() {
		const { contentId, versionOverride, excludeIds } = this.props;

		return (
			<WebItemLocation
				tagName="span"
				contentId={contentId}
				location={SYSTEM_CONTENT_METADATA}
				version={versionOverride}
			>
				{({ webItems }) => {
					let filteredWebItems = webItems;
					if (excludeIds && excludeIds.length) {
						filteredWebItems = filteredWebItems.filter((item) => !excludeIds.includes(item.id));
					}
					return (
						<>
							<WebItemList
								pageId={contentId}
								webItems={filteredWebItems}
								id="system-
                content-items"
							/>
							<ConnectAppLoadEnd
								location={SYSTEM_CONTENT_METADATA}
								items={getConnectAppsItems(filteredWebItems)}
							/>
						</>
					);
				}}
			</WebItemLocation>
		);
	}
}
